// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3kV0v","bigColWidth":"Table_bigColWidth__18O4R","biggerColWidth":"Table_biggerColWidth__3gDB-","row":"Table_row__3dQA5","col":"Table_col__V_k7F"};